import React from 'react';
import BannerHeader from 'components/Banners/BannerHeader';

const IframeBanners = () => <BannerHeader show />;

IframeBanners.propTypes = {};

export default IframeBanners;
